module.exports = __webpack_public_path__ + "static/media/sponsorship.ef6c4531.jpg";